<div
  (clickOutside)="colorPicker?.isPopoverOpen ? null : onClickOutside($event)"
  [@state]="_visibility"
  (@state.done)="_animationDone($event)"
  class="popover-container popover-booking"
>
  <div class="popover-header">
    <h4 class="title">
      {{ inquiry.guestNameView }}
    </h4>
    <ul class="list list-inline">
      <li *ngxPermissionsOnly="['canEditRental']" (click)="onClose(); onOpenRental()" class="list-inline-item cp">
        {{ rental.name }}
      </li>
      <li *ngxPermissionsExcept="['canEditRental']" class="list-inline-item">{{ rental.name }}</li>
      <li class="list-inline-item">{{ inquiry.sourceView | startCase }}</li>
    </ul>

    <i class="far fa-times btn-close" (click)="onClose()"></i>
  </div>
  <div class="popover-body">
    <div class="box-details">
      <div class="title">Booking Details</div>
      <ul>
        <li>
          <i class="fal icon-left fa-calendar"></i>
          {{ event.start | epochUTC: 'ddd MMM DD, YYYY' }}
          <small class="text-gray mlr-15">To</small>
          {{ event.end | epochUTC: 'ddd MMM DD, YYYY' }}
        </li>
        <li>
          <ng-container *ngIf="checkin">
            <small class="text-gray">Check-in:</small>
            {{ checkin | epoch: 'h:mm A' }}<br />
          </ng-container>
          <ng-container *ngIf="checkout">
            <small class="text-gray">Check-out:</small>
            {{ checkout | epoch: 'h:mm A' }}<br />
          </ng-container>
        </li>
        <li>
          <i class="fal icon-left fa-users"></i>
          {{ event.adults || 0 }} <small class="text-gray mr-15">Adults</small>

          {{ event.children || 0 }} <small class="text-gray mr-15">Children</small>

          {{ inquiry.nightsView }} <small class="text-gray mr-15">Nights</small>
        </li>
      </ul>
    </div>
    <div class="box-details">
      <div class="title">Guest Details</div>
      <ul>
        <li *ngxPermissionsOnly="['canEditInquiry']">
          <i class="fal icon-left fa-user"></i>
          <a (click)="onClose(); onEditGuest()">
            {{ inquiry.guestNameView }}
          </a>
        </li>
        <ng-container *ngxPermissionsExcept="['canEditInquiry']">
          <li *ngIf="currentUser | staffPermissions: 'name'">
            <i class="fal icon-left fa-user"></i>
            <span>
              {{ inquiry.guestNameView }}
            </span>
          </li>
        </ng-container>
        <ng-container *ngxPermissionsOnly="['canSeeGuestContacts']">
          <li *ngIf="inquiry.guest?.phone && (currentUser | staffPermissions: 'phone')">
            <i class="fal icon-left fa-phone-volume"></i>
            {{ inquiry.guest?.phone }}
          </li>
          <li *ngIf="inquiry.guest?.primaryEmail && (currentUser | staffPermissions: 'email')">
            <i class="fal icon-left fa-envelope"></i>
            {{ inquiry.guest?.primaryEmail }}
          </li>
        </ng-container>
      </ul>
    </div>
    <div *ngIf="canSeeCharges$ | async" class="box-details">
      <div *ngIf="charges$ | async" class="title">Booking Charges</div>
      <ng-container *ngIf="!isTokeetPlatform">
        <ul *ngIf="charges$ | async; let charges">
          <li class="row no-margin">
            <i class="fal icon-left fa-usd-circle"></i>
            <span class="col-4 no-padding" [innerHtml]="charges.charge || 0 | tokeetCurrency: currencySymbol"></span>
            <small class="col-4 no-padding text-gray">Base Charge</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-percent"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="charges?.extraGuests || 0 | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-6 no-padding text-gray">Additional Guests Fee</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-percent"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="charges.discountSum + charges.feeSum || 0 | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-4 no-padding text-gray">Discounts & Fees</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-cut"></i>
            <span class="col-4 no-padding" [innerHtml]="charges.taxFee || 0 | tokeetCurrency: currencySymbol"></span>
            <small class="col-4 no-padding text-gray">Taxes</small>
          </li>
          <ng-container *ngIf="tryToGetFormulaCost | call: inquiryService:inquiry | async as formulaCost">
            <li class="row no-margin">
              <strong
                [matTooltip]="currencyCode"
                matTooltipClass="text-center"
                matTooltipPosition="left"
                class="col-4 no-padding"
                [innerHtml]="formulaCost | tokeetCurrency: currencySymbol"
              ></strong>
              <small class="col-4 no-padding text-gray">Booking Formula</small>
            </li>
          </ng-container>
          <li class="row no-margin">
            <strong
              [matTooltip]="currencyCode"
              matTooltipClass="text-center"
              matTooltipPosition="left"
              class="col-4 no-padding"
              [innerHtml]="charges.sum || 0 | tokeetCurrency: currencySymbol"
            ></strong>
            <small class="col-4 no-padding text-gray">Total</small>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="isTokeetPlatform">
        <ul>
          <li class="row no-margin">
            <i class="fal icon-left fa-usd-circle"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.extraBedroomsBase | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-4 no-padding text-gray">Base Charge</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-percent"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.extraGuests | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-6 no-padding text-gray">Additional Guests Fee</small>
          </li>
          <li class="row no-margin" *ngIf="!!inquiry?.bookingEngine?.extraBedrooms">
            <i class="fal icon-left fa-percent"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.extraBedrooms | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-6 no-padding text-gray">Additional Bedrooms Fee</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-percent"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.discountTotal | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-4 no-padding text-gray">Discounts & Fees</small>
          </li>
          <li *ngFor="let fee of inquiry?.bookingEngine?.bookingFees" class="row no-margin">
            <i class="fal icon-left fa-badge-dollar"></i>
            <span class="col-4 no-padding" [innerHtml]="fee.amount | tokeetCurrency: currencySymbol"></span>
            <small class="col-4 no-padding text-gray">{{ fee.name }}</small>
          </li>
          <li class="row no-margin">
            <i class="fal icon-left fa-cut"></i>
            <span
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.taxTotal | tokeetCurrency: currencySymbol"
            ></span>
            <small class="col-4 no-padding text-gray">Taxes</small>
          </li>
          <li class="row no-margin">
            <strong
              [matTooltip]="currencyCode"
              matTooltipClass="text-center"
              matTooltipPosition="left"
              class="col-4 no-padding"
              [innerHtml]="inquiry?.bookingEngine?.total | tokeetCurrency: currencySymbol"
            ></strong>
            <small class="col-4 no-padding text-gray">Total</small>
          </li>
        </ul>
        <ul *ngIf="potentialFees()?.length > 0">
          <li class="fees-title">These booking fees may apply:</li>
          <li *ngFor="let fee of potentialFees()" class="row no-margin">
            <span class="col-4 no-padding">{{ fee.name }}</span>
            <small class="col-4 no-padding text-gray">
              {{
                fee.type === feeTypes.Percent
                  ? fee.amount + '%'
                  : (fee.amount | tokeetCurrency: currencySymbol) + ' / ' + feeModalityLabels[fee.modality]
              }}
            </small>
          </li>
        </ul>
      </ng-container>

      <ng-container *ngIf="!!inquiry.booked">
        <button
          *ngIf="paymentStatus$ | async; let paymentStatus"
          (click)="onChangePaymentStatus(paymentStatus.status)"
          [matTooltip]="getPaymentStatusTooltip | call: inquiry"
          matTooltipPosition="above"
          matTooltipClass="text-center"
          class="btn text-uppercase btn-outline-partial-paid btn-outline-{{
            getPaymentStatusClass | call: paymentStatus?.status
          }}"
        >
          <span class="fas fa-circle"></span>
          {{ paymentStatus?.status }}
        </button>
      </ng-container>
    </div>
    <div class="btn-holder">
      <app-color-picker
        #colorPicker
        [activeColor]="inquiry.attributes?.color"
        colors="inquiry"
        (change)="onChangeInquiryColor($event)"
        matTooltip="Change inquiry color"
        matTooltipPosition="above"
        [class.d-none]="!(hasPermission$ | call: permissions:'canEditInquiry' | async)"
      >
      </app-color-picker>

      <button
        *ngxPermissionsOnly="['canEditInquiry']"
        type="button"
        class="btn btn-default-outline text-uppercase"
        (click)="onClose(); onOpenMessages()"
        matTooltip="Messages"
        matTooltipPosition="above"
      >
        <span class="fal fa-comments-alt m-0" aria-hidden="true"></span>
      </button>

      <button
        *ngxPermissionsOnly="['canEditNotes']"
        type="button"
        class="btn btn-default-outline text-uppercase"
        (click)="onClose(); onOpenNotes()"
        matTooltip="Notes"
        matTooltipPosition="above"
      >
        <span class="fal fa-clipboard-list m-0" aria-hidden="true"></span>
      </button>
      <button
        *ngxPermissionsOnly="['canAddInquiry']"
        type="button"
        class="btn btn-default-outline text-uppercase"
        (click)="onClose(); onClone()"
        matTooltip="Click here to clone this booking"
        matTooltipPosition="above"
      >
        <span class="fal fa-copy m-0" aria-hidden="true"></span>
      </button>

      <button
        *ngxPermissionsOnly="['canEditInquiry']"
        type="button"
        class="btn btn-success text-uppercase"
        (click)="onClose(); onOpenInquiry()"
        matTooltip="Edit"
        matTooltipPosition="above"
      >
        <span class="fal fa-edit m-0" aria-hidden="true"></span>
      </button>
    </div>
  </div>
</div>
